import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { UserDtoSchema } from '../contracts';

const AuditChangeDtoSchema = z.object({
  field: z.string(),
  from: z.unknown().optional(),
  to: z.unknown().optional(),
  redacted: z.boolean().optional(),
});

const GetOrganizationLogsResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    id: z.string(),
    action: z.enum([
      'LOGIN',
      'LOGOUT',
      'CREATE',
      'UPDATE',
      'DELETE',
      'IMPERSONATE',
    ]),
    summary: z.string(),
    actor: UserDtoSchema,
    impersonatedBy: UserDtoSchema.nullable().optional(),
    success: z.boolean(),
    occurredAt: z.string(),
    metadata: z
      .object({ changes: z.array(AuditChangeDtoSchema).optional() })
      .passthrough()
      .nullable(),
    errorMessage: z.string().nullable(),
  })
);

export type GetOrganizationLogsRequestDto = PagePaginationRequestDto<
  {
    action?:
      | 'LOGIN'
      | 'LOGOUT'
      | 'CREATE'
      | 'UPDATE'
      | 'DELETE'
      | 'IMPERSONATE';
    search?: string;
  },
  | 'occurredAt'
  | 'action'
  | 'actorName'
  | 'actorEmail'
  | 'success'
  | 'organizationName'
>;
export type GetOrganizationLogsResponseDto = z.infer<
  typeof GetOrganizationLogsResponseDtoSchema
>;

export const getOrganizationLogs = (
  params: GetOrganizationLogsRequestDto,
  config?: AxiosRequestConfig<GetOrganizationLogsRequestDto>
) => {
  return api
    .get('/audit-logs', { params, ...config })
    .then(responseContract(GetOrganizationLogsResponseDtoSchema));
};
